/**
 * @author：
 * @update：
 * @description：
 **/
import CusPagination from "@/components/cusPagination.vue";
import axios from "axios";
import {
  exportWorkFile,
  fileEcho,
  worksList,
  worksTypeList,
} from "../../api/url";
import { detailUrl, requestUrl, transactionHttps } from "../../config/config";

export default {
  components: {
    CusPagination,
  },
  data() {
    return {
      tabsCup: 0,
      transactionHttps: transactionHttps,
      callback: detailUrl + "details?id=", //复制地址详情
      fileEcho: fileEcho, //openFile,//fileUpLoca
      worksId: "", //作品id
      worksName: "", //作品名称
      worksTypeVal: "", //作品类型
      worksTypeOption: [],
      copyrightMan: "", //著作权人
      storeName: "", //所属店铺
      author: "", //作者
      state: "", //审核状态
      goodsID: "", //商品id
      goodsName: "", //商品名称
      tableData: [], //表格数据
      page: 1,
      size: 10,
      count: 0,
      goodsList: [], //关联商品
      seeVisible: false,
      page2: 1,
      size2: 10,
      count2: 0,
      exportVisible: false,
      allChecked: false,
      checkGroupBasic: [],
      checkGroupAuthors: [],
      checkGroupSpu: [],
      checkGroupCompact: [],
      allGroup: Object.freeze({
        basic: [
          { title: "作品编号", name: "uniqueId", type: "VALUE" },
          { title: "登记证号", name: "registerId", type: "VALUE" },
          { title: "作品类别", name: "category", type: "VALUE" },
          { title: "作品名称", name: "name", type: "VALUE" },
          { title: "作品署名", name: "signature", type: "VALUE" },
          { title: "创作性质", name: "nature", type: "VALUE" },
          { title: "创作性质说明", name: "natureDesc", type: "VALUE" },
          { title: "作词人", name: "lyricists", type: "VALUE" },
          { title: "作曲人", name: "composers", type: "VALUE" },
          { title: "表演者", name: "performers", type: "VALUE" },
          { title: "拍摄地点", name: "filmLocation", type: "VALUE" },
          { title: "制片人姓名", name: "producer", type: "VALUE" },
          { title: "公映地点", name: "publicShowVenue", type: "VALUE" },
          { title: "公映日期", name: "publicShowDate", type: "VALUE" },
          { title: "制作完成日期", name: "finishedDate", type: "VALUE" },
          { title: "是否发表", name: "publishState", type: "VALUE" },
          { title: "首次发表日期", name: "publishDate", type: "VALUE" },
          { title: "出证机构", name: "organization", type: "VALUE" },
          { title: "登记日期", name: "registerDate", type: "VALUE" },
          { title: "权利范围", name: "rights", type: "VALUE" },
          { title: "权利范围说明", name: "rightsDesc", type: "VALUE" },
          { title: "是否已转让权利", name: "transfer", type: "VALUE" },
          { title: "转让权利", name: "transferRights", type: "VALUE" },
          { title: "转让权利说明", name: "transferRightsDesc", type: "VALUE" },
          { title: "是否已许可使用", name: "permission", type: "VALUE" },
          { title: "许可使用权利", name: "permissionRights", type: "VALUE" },
          {
            title: "许可使用权利说明",
            name: "permissionRightsDesc",
            type: "VALUE",
          },
          // { title: '权利归属方式', name: 'ownership', type: 'VALUE' },
          { title: "提交审核时间", name: "submitTime", type: "VALUE" },
          // { title: '状态', name: 'state', type: 'VALUE' },
          { title: "批次号", name: "batchNumber", type: "VALUE" },
        ],
        owners: [
          { title: "名称", name: "name", type: "VALUE" },
          { title: "类别", name: "category", type: "VALUE" },
          { title: "国籍", name: "nationality", type: "VALUE" },
          { title: "省份", name: "province", type: "VALUE" },
          { title: "城市", name: "city", type: "VALUE" },
          { title: "证件类型", name: "idType", type: "VALUE" },
          { title: "证件号码", name: "idNumber", type: "VALUE" },
          { title: "署名情况", name: "signature", type: "VALUE" },
          { title: "别名", name: "alias", type: "VALUE" },
        ],
        spus: [{ title: "商品名称", name: "name", type: "VALUE" }],
        contracts: [
          { title: "合同名称", name: "name", type: "VALUE" },
          { title: "签署人", name: "signatories", type: "VALUE" },
          { title: "生效日期", name: "effectiveDate", type: "VALUE" },
        ],
      }),
    };
  },
  // 自定义方法
  methods: {
    cupBtn(num) {
      console.log(num);
      if (num == 0) {
        this.state = "";
        this.dataList();
        this.tabsCup = 0;
      } else if (num == 1) {
        this.state = "STATE_APPROVED";
        this.dataList();
        this.tabsCup = 1;
      } else if (num == 2) {
        this.state = "STATE_REJECTED";
        this.dataList();
        this.tabsCup = 2;
      } else if (num == 3) {
        this.state = "STATE_CHECK_PENDING";
        this.dataList();
        this.tabsCup = 3;
      }
    },
    //打开商品详情
    opGoodsDetails(id) {
      window.open(transactionHttps + "#/details?id=" + id);
    },
    worksTyle() {
      this.$ajax.get(worksTypeList, { id: 1 }).then(
        (res) => {
          let datas = [];
          for (let i = 0; i < res.data.attributeGroups.length; i++) {
            if (res.data.attributeGroups[i].name == "作品信息") {
              datas = res.data.attributeGroups[i].groupTemplates;
              for (let j = 0; j < datas.length; j++) {
                if (datas[j].attributeTemplate.name == "作品类型") {
                  let arr = datas[j].attributeTemplate.value.split(","); //获取的数据值
                  let dataArr = []; //获取到组合好的数据
                  for (let k = 0; k < arr.length; k++) {
                    let obj = {
                      id: arr[k],
                      label: arr[k],
                      value: arr[k],
                      disabled: false,
                    };
                    dataArr.push(obj);
                  }
                  this.worksTypeOption = dataArr;
                }
              }
              break;
            }
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            showClose: true,
            message: err.data,
            type: "error",
            center: true,
            duration: 3000,
          });
        }
      );
    },
    //列表数据
    dataList() {
      let data = {
        uniqueId: this.worksId, //作品id
        name: this.worksName, //作品名称
        category: this.worksTypeVal, //作品类型
        ownerName: this.copyrightMan, //著作权人
        authorName: this.author, //作者
        state: this.state, //审核状态
        spuId: this.goodsID, //商品id
        spuName: this.goodsName, //商品名称
        storeName: this.storeName, //所属店铺
        pageNumber: this.page,
        pageSize: this.size,
      };
      this.$ajax.get(worksList, data).then(
        (res) => {
          console.log(res);
          this.count = res.data.total;
          this.tableData = res.data.rows;
        },
        (err) => {
          console.log(err);
          this.$message({
            showClose: true,
            message: err.data,
            type: "error",
            center: true,
            duration: 3000,
          });
        }
      );
    },
    //查看关闭
    seeClose(done) {
      done();
      this.goodsList = []; //关联商品
      this.page2 = 1; //商品页数
    },
    //点击查看
    toSee(data) {
      console.log(data);
      this.goodsCountList = data;
      this.count2 = data.length;
      this.goodsList = data.slice(0, this.size2);
      this.seeVisible = true;
    },
    //查看取消
    qxSee() {
      this.seeVisible = false;
      this.goodsList = []; //关联商品
      this.page2 = 1; //商品页数
    },
    //重置
    resetBtn() {
      this.worksId = ""; //作品id
      this.worksName = ""; //作品名称
      this.worksTypeVal = ""; //作品类型
      this.copyrightMan = ""; //著作权人
      this.author = ""; //作者
      this.state = ""; //审核状态
      this.goodsID = ""; //商品id
      this.goodsName = ""; //商品名称
      this.storeName = ""; //所属店铺
      this.page = 1;
      this.tabsCup = 0;
      this.dataList();
    },
    getLabelList(checkGroup, allGroupPro) {
      //通过已选中的数组属性获取数组对象
      let objList = [];
      let allGroupList = this.allGroup[allGroupPro];
      for (let index in this[checkGroup]) {
        for (let i in allGroupList) {
          if (allGroupList[i].name === this[checkGroup][index]) {
            objList.push(allGroupList[i]);
            break;
          }
        }
      }
      return objList;
    },
    // 导出xls
    exportFile() {
      if (
        !this.checkGroupAuthors.length &&
        !this.checkGroupSpu.length &&
        !this.checkGroupCompact.length &&
        !this.checkGroupBasic.length
      ) {
        this.$message.info("请至少选择一个选项");
        return;
      }
      const fields = this.getLabelList("checkGroupBasic", "basic");
      const checkGroupAuthors = {
        title: "著作权人",
        name: "owners",
        type: "COLLECTION",
        fields: this.getLabelList("checkGroupAuthors", "owners"),
      };
      this.checkGroupAuthors.length && fields.push(checkGroupAuthors);
      const checkGroupSpu = {
        title: "关联商品",
        name: "spus",
        type: "COLLECTION",
        fields: this.getLabelList("checkGroupSpu", "spus"),
      };
      this.checkGroupSpu.length && fields.push(checkGroupSpu);
      const checkGroupCompact = {
        title: "合同",
        name: "contracts",
        type: "COLLECTION",
        fields: this.getLabelList("checkGroupCompact", "contracts"),
      };
      this.checkGroupCompact.length && fields.push(checkGroupCompact);
      const data = {
        type: "COLLECTION",
        title: "基本信息",
        fields,
      };
      const filter = {
        uniqueId: this.worksId, //作品id
        name: this.worksName, //作品名称
        category: this.worksTypeVal, //作品类型
        ownerName: this.copyrightMan, //著作权人
        authorName: this.author, //作者
        state: this.state, //审核状态
        spuId: this.goodsID, //商品id
        spuName: this.goodsName, //商品名称
        storeName: this.storeName, //所属店铺
      };
      for (let key in filter) {
        if (filter[key] === "") {
          delete filter[key];
        }
      }
      this.$loading({
        fullscreen: true,
        text: "导出中...这可能需要很长一段时间，请耐心等待。",
      });
      axios({
        url: requestUrl + exportWorkFile,
        method: "post",
        data: data,
        params: filter,
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (!res) return;
          let url = window.URL.createObjectURL(
            new Blob([res.data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
          );
          const aEle = document.createElement("a"); // 创建a标签
          aEle.href = url;
          document.body.appendChild(aEle);
          aEle.click(); // 点击下载
          document.body.removeChild(aEle); // 下载完成移除元素
          window.URL.revokeObjectURL(url); // 释放掉blob对象
          this.$loading().close();
          this.exportVisible = false; //关闭弹窗
        })
        .catch((err) => {
          this.$loading().close();
          this.$message.info("下载失败！");
        });
    },
    resetField() {
      this.checkGroupBasic = [];
      this.checkGroupCompact = [];
      this.checkGroupSpu = [];
      this.checkGroupAuthors = [];
      this.allChecked = false;
    },
    checkAll() {
      if (this.allChecked) {
        this.checkGroupBasic = this.allGroup.basic.map((item) => item.name);
        this.checkGroupCompact = this.allGroup.contracts.map(
          (item) => item.name
        );
        this.checkGroupSpu = this.allGroup.spus.map((item) => item.name);
        this.checkGroupAuthors = this.allGroup.owners.map((item) => item.name);
      } else {
        this.resetField();
      }
    },
  },
  // 数据观察监听
  watch: {
    page(newData, oldData) {
      this.dataList();
    },
    size(newData, oldData) {
      this.dataList();
    },
    page2(newData, oldData) {
      this.page2 = newData;
      let data = this.goodsCountList.slice(
        (this.page2 - 1) * this.size2,
        this.page2 * this.size2
      );
      this.goodsList = data;
    },
    size2(newData, oldData) {
      this.size2 = newData;
      let data = this.goodsCountList.slice(
        (this.page2 - 1) * this.size2,
        this.page2 * this.size2
      );
      this.goodsList = data;
    },
  },
  // 计算数据
  computed: {
    isIndeterminate() {
      return (
        (!!this.checkGroupAuthors.length &&
          this.checkGroupAuthors.length < this.allGroup.owners.length) ||
        (!!this.checkGroupBasic.length &&
          this.checkGroupBasic.length < this.allGroup.basic.length) ||
        (!!this.checkGroupCompact.length &&
          this.checkGroupCompact.length < this.allGroup.contracts.length) ||
        (!!this.checkGroupSpu.length &&
          this.checkGroupSpu.length < this.allGroup.spus.length)
      );
    },
  },
  // 组件数据创建之前
  beforeCreate() {},
  // 组件数据创建完成
  created() {
    if (this.$route.query.state) {
      this.state = this.$route.query.state;
    }
    this.worksTyle();
  },
  // 组件挂载完成之前
  beforeMount() {
    this.dataList();
  },
  // 组件挂载完成
  mounted() {},
  // 组件即将销毁
  beforeDestroy() {},
  // 组件销毁
  destroyed() {},
  // 组件激活
  activated() {},
  // 组件冻结
  deactivated() {},
};
